import apiClient from '../api/apiClient';

export const getWalletBalance = () => apiClient.get('/wallet/');
export const getTransactions = () => apiClient.get('/wallet/transactions/');
export const buyGiftCard = (amount) => apiClient.post('/wallet/gift-cards/buy/', { amount });
export const redeemGiftCard = (code) => apiClient.post('/wallet/gift-cards/redeem/', { code });
export const makeDonation = (amount) => apiClient.post('/wallet/donate/', { amount });
export const initiatePayment = (amount) => apiClient.post('/wallet/payment/initiate/', { amount });